import {Component, OnInit, ViewChild} from '@angular/core';
import {
    ConfirmOptionsDate,
    ConfirmOptionsInput,
    ConfirmOptionsInputWithEmpty,
    ConfirmOptionsMultiBtn,
    ConfirmOptionsWithSearch,
    ConfirmOptionsWithList,
    ConfirmRequest,
} from './confirm.service';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm.component.html',
})
export class ConfirmComponent<T> implements OnInit {
    confirmRequest: ConfirmRequest<T>;
    value: any = null;

    @ViewChild('modal', {static: true}) modalTemplate;

    get options() {
        return this.confirmRequest.options;
    }

    get dateOptions() {
        return (this.options as ConfirmOptionsDate);
    }

    get inputOptions() {
        return (this.options as ConfirmOptionsInput);
    }

    get inputWithEmptyOptions() {
        return (this.options as ConfirmOptionsInputWithEmpty);
    }

    get list() {
        return (this.options as ConfirmOptionsWithList<T>)?.list;
    }

    get listOptions() {
        return (this.options as ConfirmOptionsWithList<T>);
    }

    get searchOptions() {
        return (this.options as ConfirmOptionsWithSearch<T>);
    }

    get confirmBtns() {
        return (this.options as ConfirmOptionsMultiBtn<T>)?.confirmBtns;
    }

    get confirmBtn() {
        return this.options?.confirmBtn;
    }

    respond(confirmResponse) {
        this.confirmRequest.respond(confirmResponse && this.value || confirmResponse);
    }

    isDisabled() {
        if (this.inputWithEmptyOptions?.allowEmpty) return false;
        return !this.value && (this.listOptions?.list?.length || this.dateOptions?.date || this.inputOptions?.input);
    }

    ngOnInit(): void {
        if (this.listOptions?.autoSelectSingleItem) {
            this.value = this.list[0].value;
        }
        if (this.list && this.listOptions?.initialValue) {
            const autoSelectWasPerformed = this.list.some(item => {
                const autoSelect = this.listOptions.initialValue === item.value; // Only works with primitives, NgSelect will produce warnings for Objects
                if (autoSelect) this.value = item.value;
                return autoSelect;
            });
            if (!autoSelectWasPerformed) console.warn(`[ConfirmComponent] The specified initial value "${this.listOptions.initialValue}" is not found among the options!`);
        } else if (this.dateOptions?.initialValue) {
            this.value = this.dateOptions.initialValue;
        }
    }

    togglePredefinedText(text: string) {
        const included = this.value?.includes(text);
        if (included) {
            this.value = this.value.replace(`${text}\n\n`, '').replace(`\n\n${text}`, '').replace(text, '');
        } else {
            this.value = this.value?.trim() ? `${this.value}\n\n${text}` : text;
        }
    }

    togglePredefinedResponse(option: string) {
        const group = this.inputOptions.predefinedStructuredResponses.find(g => g.options.includes(option));
        if (!group) return;

        const formattedTitle = `**${group.title}**`;
        const formattedOption = `- ${option}`;
        const allFormattedOptionsInGroup = group.options.map(opt => `- ${opt}`);

        const lines = this.value?.split('\n').map(line => line.trim()) || [];
        const isOptionCurrentlyInText = lines.includes(formattedOption);

        if (isOptionCurrentlyInText) {
            const updatedLines = lines.filter(line => line !== formattedOption);
            const otherOptionsExist = updatedLines.some(line => allFormattedOptionsInGroup.includes(line));

            if (!otherOptionsExist) {
                const titleIndex = updatedLines.indexOf(formattedTitle);
                if (titleIndex > -1) {
                    updatedLines.splice(titleIndex, 1);
                    if (titleIndex > 0 && updatedLines[titleIndex - 1].trim() === '') {
                        updatedLines.splice(titleIndex - 1, 1);
                    }
                }
            }
            this.value = updatedLines.join('\n').trim();
        } else {
            const titleIndex = lines.findIndex(line => line === formattedTitle);

            if (titleIndex > -1) {
                let lastOptionIndex = titleIndex;
                for (let i = titleIndex + 1; i < lines.length; i++) {
                    if (allFormattedOptionsInGroup.includes(lines[i])) {
                        lastOptionIndex = i;
                    } else if (lines[i].trim() !== '') {
                        break;
                    }
                }
                lines.splice(lastOptionIndex + 1, 0, formattedOption);
            } else {
                if (this.value?.trim().length > 0) {
                    lines.push('');
                }
                lines.push(formattedTitle);
                lines.push(formattedOption);
            }
            this.value = lines.join('\n').trim();
        }
    }
}
